export class EditBranchInstallationsReqData {
    installationNames: string[] = null;
    branchId: number;

    constructor(installationNames: string[], branchId: number) {
        this.installationNames = installationNames;
        this.branchId = branchId;
    }
}
